module.exports = __webpack_public_path__ + "static/media/access-denied.e406ea2e.png";